module.exports = __webpack_public_path__ + "img/camera.cefe032c.png";